<template>
  <transition name="fade-up-slide">
    <div class="lr2-modal" v-show="show" @click="close">
      <div class="lr-box" @click.stop>
        <div class="d-flex other-fields">
          <!-- Journey -->
          <div class="cabin-box">
            <div class="c-label">Journey Type</div>
            <div class="d-flex radio-fields flex-column">
              <label>
                <input type="radio" name="journey" v-model="isReturning" :value="true" />
                Roundtrip
              </label>
              <label>
                <input type="radio" name="journey" v-model="isReturning" :value="false" />
                One-way
              </label>
            </div>
            <!-- <select v-model="isReturning" class="min-cabin">
              <option :value="true">Roundtrip</option>
              <option :value="false">One-way</option>
            </select> -->
          </div>

          <!-- CABIN CLASS -->
          <div class="cabin-box">
            <div class="c-label">Cabin Class</div>
            <div class="d-flex radio-fields flex-column">
              <div class="d-flex radio-fields-inner">
                <label>
                  <input type="radio" name="cabin" v-model="minCabin" value="Economy" />
                  Economy
                </label>
                <label>
                  <input type="radio" name="cabin" v-model="minCabin" value="PremiumEconomy" />
                  Premium Economy
                </label>
              </div>
              <div class="d-flex radio-fields-inner">
                <label>
                  <input type="radio" name="cabin" v-model="minCabin" value="Business" />
                  Business
                </label>
                <label>
                  <input type="radio" name="cabin" v-model="minCabin" value="First" />
                  First
                </label>
              </div>
            </div>
            <!-- <select v-model="minCabin" class="min-cabin">
              <option v-for="(cabin, i) in booking.cabinList" :key="i" :value="cabin">{{ cabinLabel(cabin) }}</option>
            </select> -->
          </div>
        </div>

        <!-- HEAD -->
        <div class="d-flex align-end lr-date-head">
          <div class="date-head-box">
            <div class="dep-ret-label">Depart</div>
            <div class="date-val" v-if="tripType == 'roundtrip'">{{ dateFormat(cal.highlighted.from) }}</div>
            <div class="date-val" v-else>{{ dateFormat(cal.current) }}</div>
          </div>
          
          <div v-if="tripType == 'roundtrip'" class="lr-date-head-arrow">
            <i class="fas fa-arrow-right fa-fw"></i>
          </div>

          <div v-if="tripType == 'roundtrip'" class="date-head-box">
            <div class="dep-ret-label">Return</div>
            <div class="date-val">{{ dateFormat(cal.highlighted.to) }}</div>
          </div>
        </div>

        <!-- BODY-->
        <div class="lr-date-body d-flex">
          <div>
            <datepicker :inline="true" initial-view="day" class="lr-datepicker"
              v-model="cal.current" :disabled="disabledDate"
              :highlighted="cal.highlighted"
              @selected="dateSelected"
            ></datepicker>
          </div>
        </div>

        <div class="date-error-msg" v-if="!!errorMsg">{{errorMsg}}</div>

        <!-- Action -->
        <div class="d-flex justify-space-between">
          <span class="lr-btn" @click="close">{{ $t('common.cancel') }}</span>
          <span class="lr-btn" @click="setDate">{{ $t('serviceSelect.apply') }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment-timezone'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'departure-modal',
  components: { Datepicker },
  props: ['noCommit', 'isRt'],
  data () {
    return {
      tripType: 'roundtrip',
      selectedDate: moment.tz(this.$store.state.reservation.leg1.timezone).format('MM/DD/YYYY'),
      returnDate: moment.tz(this.$store.state.reservation.leg1.timezone).add(1, 'days').format('MM/DD/YYYY'),
      today: moment.tz(this.$store.state.reservation.leg1.timezone),
      errorMsg: '',
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
      render: true,
      cal: {
        previous: null,
        current: null,
        returnDate: null,
        highlighted: {
          from: null,
          to: null
        }
      }
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    d2dTimeBuffer () { return this.booking.settings.timeBuffer },
    show () { return this.filters.departure.show },
    webTimeBuffer () { return this.$store.state.reservation.webTimeBuffer },
    dateTimePickerData () { return this.$store.state.serviceSelection.dateTimePicker },
    disabledDate () {
      let maxDays = moment().add(329, 'days')
      if (this.today.format('MM') === '01') {
        return {
          from: new Date(
            maxDays.format('YYYY'),
            maxDays.format('MM'),
            maxDays.format('DD')
          ),
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        from: new Date(
          maxDays.format('YYYY'),
          maxDays.format('MM'),
          maxDays.format('DD')
        ),
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    disabledDateReturn () {
      if (!this.selectedDate) return this.disabledDate
      let date = moment(this.selectedDate, 'MM/DD/YYYY')
      let maxDays = moment().add(329, 'days')
      if (date.format('MM') === '01') {
        return {
          from: new Date(
            maxDays.format('YYYY'),
            maxDays.format('MM'),
            maxDays.format('DD')
          ),
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        from: new Date(
          maxDays.format('YYYY'),
          maxDays.format('MM'),
          maxDays.format('DD')
        ),
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    },
    isMilitaryTime () {
      if (this.$store.state.reservation.charter.MilitaryTimeWidget) {
        this.hourFormat = 'HH'
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      }
      return this.$store.state.reservation.charter.MilitaryTimeWidget
    },
    minCabin: {
      get () { return this.booking.minCabin },
      set (x) { this.$store.commit('booking/setOthersData', {minCabin: x}) }
    },
    isReturning: {
      get () { return this.filters.departure.isReturning },
      set (x) {
        this.selectedDate = moment(this.cal.current).format('MM/DD/YYYY')

        this.tripType = x ? 'roundtrip' : 'single'
        this.$store.commit('booking/setDepartureData', {isReturning: x})
        if (x) this.returnDate = this.selectedDate

        let widgetType = this.locations.isAirportPickup && this.locations.isAirportDropoff ? 'flight' : 'd2d'
        this.$store.commit('other/setOtherData', {widgetTab: widgetType})

        this.updateCalendar()
      }
    }
  },
  methods: {
    close () {
      this.$store.commit('booking/setDepartureData', {show: false})
    },
    setDate () {
      this.errorMsg = ''
      let isReturning = this.tripType === 'roundtrip'
      let startDate = isReturning ? moment(this.cal.highlighted.from) : moment(this.cal.current)
      let endDate = ''
      let format = 'MM/DD/YYYY'
      if (isReturning) {
        endDate = moment(this.cal.highlighted.to)
        if (!startDate.isBefore(endDate) && this.selectedDate !== this.returnDate) {
          this.errorMsg = 'Return Trip must be in the future.'
          return
        }
      }
      if (this.noCommit) {
        this.$emit('dateVal', {
          date: startDate.format(format),
          return: isReturning ? endDate.format(format) : '',
          isReturning: isReturning
        })
      } else {
        this.$store.commit('booking/setDepartureData', {
          date: startDate.format(format),
          return: isReturning ? endDate.format(format) : '',
          isReturning: isReturning
        })
      }
      this.selectedDate = startDate.format(format)
      if (isReturning) this.returnDate = endDate.format(format)

      this.$emit('newDate')
      this.close()
    },
    printDate (date) {
      return moment(date).format('MMM DD, YYYY')
    },
    dateFormat (x) {
      if (!x) return ''
      return moment(x).format('ddd, MMM DD')
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    },
    dateSelected (date) {
      if (!this.isReturning) return
      this.cal.previous = this.cal.current

      let current = moment(date)
      let previous = moment(this.cal.previous)

      if (current.isSame(previous)) {
        this.cal.highlighted.from = null
        this.cal.highlighted.to = null
        return
      }

      if (previous.isBefore(current)) {
        this.cal.highlighted.from = this.cal.previous
        this.cal.highlighted.to = date
        this.cal.returnDate = date
        return
      }

      this.cal.highlighted.to = this.cal.previous
      this.cal.returnDate = this.cal.previous
      this.cal.highlighted.from = date
    },
    updateCalendar () {
      let selctedDateJS = moment(this.selectedDate, 'MM/DD/YYYY').toDate()
      let returnDateJS = moment(this.returnDate, 'MM/DD/YYYY').toDate()

      this.cal.current = selctedDateJS
      this.cal.highlighted = {
        from: selctedDateJS,
        to: returnDateJS
      }
      if (this.tripType === 'single') this.cal.highlighted.to = null
      if (this.cal.highlighted.from === 'Invalid Date') this.cal.highlighted.from = this.cal.highlighted.to
    }
  },
  watch: {
    tripType (val) {
      this.errorMsg = ''
    },
    d2dTimeBuffer (val) {
      // this.today = moment().add(val, 'minutes')
      this.selectedDate = moment().add(val, 'minutes').add(2, 'days').format('MM/DD/YYYY')
      this.returnDate = moment().add(val, 'minutes').add(3, 'days').format('MM/DD/YYYY')

      // let self = this
      // self.$nextTick(() => {
      //   if (self.selectedDate.substring(0, 2) !== self.returnDate.substring(0, 2)) {
      //     let el = document.querySelector('#rtDatepicker .vdp-datepicker__calendar header .prev')
      //     el.click()
      //   }
      // })
    },
    show (val) {
      if (val) {
        this.tripType = this.booking.filters.departure.isReturning ? 'roundtrip' : 'single'
        if (typeof this.isRt === 'boolean') this.tripType = this.isRt ? 'roundtrip' : 'single'

        this.cal.current = moment(this.selectedDate, 'MM/DD/YYYY').toDate()
        this.updateCalendar()
      }
    }
  },
  mounted () {
    this.tripType = this.booking.filters.departure.isReturning ? 'roundtrip' : 'single'
    this.selectedDate = moment().add(this.d2dTimeBuffer, 'minutes').add(2, 'days').format('MM/DD/YYYY')
    this.returnDate = moment().add(this.d2dTimeBuffer, 'minutes').add(5, 'days').format('MM/DD/YYYY')

    if (this.noCommit) {
      this.selectedDate = this.filters.departure.date
      this.returnDate = this.filters.departure.return
    }

    this.cal.highlighted = {
      from: moment(this.selectedDate, 'MM/DD/YYYY').toDate(),
      to: moment(this.returnDate, 'MM/DD/YYYY').toDate()
    }
    this.cal.current = this.cal.highlighted.from
  }
}
</script>

<style lang="scss" scoped>
.lr-box{
  padding: 20px;
  width: 100%;
  max-width: 800px;
  text-align: left;
  line-height: 1;
}

.other-fields{
  gap: 40px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.radio-fields{
  gap: 10px;
  padding-top: 5px;

  label{
    min-width: 110px;
  }
  input{
    vertical-align: -1px;
    margin-right: 3px;
  }
  .radio-fields-inner{
    padding-top: 0;
    gap: 20px;
  }
}

.cabin-box{
  margin-bottom: 20px;
  .c-label{
    font-size: 14px;
    font-weight: 600;
    color: #333;
    letter-spacing: .5px;
    margin-bottom: 5px;
  }
  select{
    padding: 10px 5px;
    width: 200px;
    border-color: #aaa;
  }
}

.lr-date-head{
  gap: 20px;
  margin-bottom: 20px;
}
.dep-ret-label{
  font-size: 14px;
  color: #9F9F9F;
  letter-spacing: .5px;
  margin-bottom: 10px;
}
.date-val{
  color: #192024;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: .6px;
}
.fa-arrow-right{
  font-size: 18px;
}

.lr-date-body{
  margin-bottom: 20px;
}

.datetimepicker{
  background-color: #fff;
  max-width: 520px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
}

.date-error-msg{
  font-size: 14px;
  padding: 5px;
  display: block;
  color: #ef4b4b;
  background: #fde5e5;
  border-radius: 4px;
  border: 1px solid #ef4b4b;
  line-height: 1.4;
  margin-bottom: 20px;
}

@media only screen and (max-width: 641px) {
  .lr2-modal{
    overflow: none;
  }
  .lr-box{
    height: 100%;
    overflow-y: auto;
  }

  .lr-date-head{
    gap: 0;
  }
  .date-head-box{
    border: 1px solid #CCD0E2;
    width: 50%;
    padding: 10px 15px;

    &:first-child{
      border-radius: 4px 0 0 4px;
    }
    &:last-child{
      border-radius: 0 4px 4px 0;
    }
  }
  .dep-ret-label{
    margin-bottom: 5px;
  }
  .lr-date-head-arrow{
    display: none;
  }

  .lr-date-body{
    flex-direction: column;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?046b2208